import React from 'react';

import Css from './Desktop.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

const desktop = props => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className={Css.footer + ' pl-3 pr-3'}>
      <Row className={'align-items-center'} style={{ height: '100%' }}>
        <Col
          md={'auto'}
          style={{ whiteSpace: 'nowrap' }}
          className={props.hideNav ? 'text-center w-100' : ''}
        >
          <FontAwesomeIcon icon={['far', 'copyright']} />
          &nbsp; Copyright {currentYear} JetSuite Air
        </Col>
        {!props.hideNav && (
          <Col>
            <Nav className={'mr-4'}>
              <NavItem>
                <Link to="/contact-us" className={'nav-link'}>
                  Contact Us
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/careers" className={'nav-link'}>
                  Careers
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/news" className={'nav-link'}>
                  In the news
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/faq" className={'nav-link'}>
                  Faq
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/partners" className={'nav-link'}>
                  Partners
                </Link>
              </NavItem>
              <NavItem>
                <a
                  href="https://account.jetsuite.com/suitedeal/"
                  className={'nav-link'}
                >
                  Suitedeals
                </a>
              </NavItem>
              <NavItem>
                <NavLink href="https://www.jsx.com" target={'_blank'}>
                  JSX
                </NavLink>
              </NavItem>
              <NavItem>
                <Link to="/leadership" className={'nav-link'}>
                  Leadership
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/legal" className={'nav-link'}>
                  Legal
                </Link>
              </NavItem>
            </Nav>
          </Col>
        )}
        {!props.hideNav && (
          <Col md={'auto'} style={{ whiteSpace: 'nowrap' }}>
            <Nav>
              <NavItem>
                <NavLink
                  href="https://www.instagram.com/jetsuite/"
                  target={'_blank'}
                  className={'pl-2 pr-2'}
                >
                  <FontAwesomeIcon icon={['fab', 'instagram']} />
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="https://www.facebook.com/JetSuiteAir/"
                  target={'_blank'}
                  className={'pl-2 pr-2'}
                >
                  <FontAwesomeIcon icon={['fab', 'facebook-square']} />
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="https://www.linkedin.com/company/jetsuite/"
                  target={'_blank'}
                  className={'pl-2 pr-2'}
                >
                  <FontAwesomeIcon icon={['fab', 'linkedin']} />
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        )}
      </Row>
    </footer>
  );
};

export default desktop;



// WEBPACK FOOTER //
// ./src/components/Footer/Desktop/Desktop.js